import SpriteSymbol from "../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loading",
  "use": "loading-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"loading\"><path d=\"M15.438 8.563q-.234 0-.398-.164t-.164-.398q0-1.406-.547-2.672-.516-1.234-1.469-2.188t-2.188-1.484Q9.406 1.126 8 1.126q-.234 0-.398-.164T7.438.564t.164-.398T8 .002q1.625 0 3.109.625 1.438.609 2.547 1.719t1.719 2.547Q16 6.377 16 8.002q0 .234-.164.398t-.398.164z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/loading.svg
// module id = 358
// module chunks = 0